import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { EDTIOR_RESTRICTION_SOURCES } from 'reactApp/ui/EditorRestriction/EditorRestriction.const';

type EditingDocumentRestrictionsType = 'a' | 'b' | 'c' | undefined;

export const editingDocumentRestrictions: EditingDocumentRestrictionsType = !IS_WEBVIEW && getFeature('editing-document-restrictions');

export const editingDocumentRestrictionsQuota: number = (getFeature('editing-document-restrictions-quota') || 0) * 1024 * 1024 * 1024; // размер квоты в ГБ;

export const editingDocumentRestrictionsB = editingDocumentRestrictions === 'b';
export const editingDocumentRestrictionsC = editingDocumentRestrictions === 'c';
export const isEditingRestrictedABEnabled = editingDocumentRestrictionsB || editingDocumentRestrictionsC;

registerExperiment(
    '512r7',
    editingDocumentRestrictions,
    [
        AnalyticEventNames.EDITOR_VIEWER_OPEN,
        AnalyticEventNames.EDITOR_BUTTON_SHOW,
        AnalyticEventNames.EDITOR_BUTTON_CLICK,
        AnalyticEventNames.EDITOR_TOOLTIP_SHOW_512,
        AnalyticEventNames.EDITOR_TOOLTIP_CLICK_512,
        AnalyticEventNames.EDITOR_TOOLTIP_CLICK_TARIFF_512,

        AnalyticEventNames.EDITOR_VIEWER_OPEN_CONTENT,
        AnalyticEventNames.EDITOR_BALLOON_SHOW_512,
        AnalyticEventNames.EDITOR_BALLOON_CLICK_512,
        AnalyticEventNames.EDITOR_BALLOON_CLICK_TARIFF_512,
        AnalyticEventNames.EDITOR_BALLOON_CLOSE_512,

        AnalyticEventNames.EDITOR_SPLASHSCREEN_ALERT_SHOW_512,
        AnalyticEventNames.EDITOR_SPLASHSCREEN_ALERT_CLICK_512,
        AnalyticEventNames.EDITOR_SPLASHSCREEN_ALERT_CLICK_TARIFF_512,
        AnalyticEventNames.EDITOR_SPLASHSCREEN_ALERT_CLOSE_512,

        AnalyticEventNames.FAST_CHECKOUT_SHOWN,
        AnalyticEventNames.TARIFF_BUY,
    ],
    {
        sendXrayArgs: {
            TARIFF_BUY: ({ paySource }, { eventName }) => ({
                eventName: paySource?.includes(EDTIOR_RESTRICTION_SOURCES.editor_less_512gb) ? 'er512_buy' : eventName,
            }),
            FAST_CHECKOUT_SHOWN: ({ paySource }, { eventName }) => ({
                eventName: paySource?.includes(EDTIOR_RESTRICTION_SOURCES.editor_less_512gb) ? 'er512_checkout' : eventName,
            }),
        },
    }
);
